module.exports = "https://venezia-network.servercdn.it/static/img/footer_03.svg?7512069c2b7b028f207e3b41e0be30b9";